<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
會員中心              </p>
	</div>
   <div class="mem-full">

 <Center title='9' />

<div class="mem-con">
	<div class="mem-jin">
		
	
	會員中心 / <b>積分</b>
	
		</div>
	<div class="gift-tit">
		<div class="con1">
			<router-link to="/user/gift">
			<p>可用積分</p>
			<h1>{{total}}</h1>
			</router-link>
		</div>
		<div>
			<p>我的兌換</p>
			<h1>{{exchange}}</h1>
		</div>
	</div>
 <el-tabs v-model="activeName" @tab-click="handleClick">
		    <el-tab-pane label="禮品" name="0">
				
				<div class="login-r1">
				
							<div class="gift-tap">
								<div class="h-button" :class="{'but2':scene==1}" @click="sandHand(1)">待支付</div>
								<div class="h-button" :class="{'but2':scene==2}" @click="sandHand(2)">等待兌換</div>
								<div class="h-button" :class="{'but2':scene==3}" @click="sandHand(3)">等待交貨</div>
								<div class="h-button" :class="{'but2':scene==4}" @click="sandHand(4)">完成</div>
							</div>
				
					   <div class="home-arr gift-con">
						   
				
					   	   <div class="integral">
					   		   <ul>
								 
					   			<li v-for="item in hand">
									<div class="cont">
										<el-row gutter="20" type="flex" align="middle">
											<el-col span="5">
												
												<img class="pic" :src="item.products.image" />
											</el-col>
											 <el-col span="6" class="l1">
											<p>{{item.products.title}}</p>
										
											 <p>*{{item.products.num}}</p>
											 <p>{{item.jifen}} 積分</p>
										</el-col>
										<el-col span="4" class="l1 sim">
											<p>運費</p>
											<p><b>￥ {{item.price}}</b></p>
										
											 
										</el-col>
										<el-col span="4" class="l1 sim">
											<div v-if="item.status==-5" class="h-button but2 but3"><router-link :to="'/user/details?id='+item.id">支付</router-link></div>
											<p v-else>{{item.statusInfo}}</p>
											<p><span><router-link :to="'/user/details?id='+item.id">訂單詳情</router-link></span></p>
											
										
											 
										</el-col>
											  <el-col span="5" class="l1 sim">
											  	<div v-if="item.status==3" class="h-button but2" @click="confirm(item.id)">確認收貨</div>
											  	<div v-if="item.status==-5" class="h-button but4" @click="cancel(item.id)">取消訂單</div>
											  	<div v-if="item.status==-1||item.status==4" class="h-button" @click="del(item.id)">刪除訂單</div>
											  
											  	 
											  </el-col>
											
											
											  </el-row>
									</div>
								
								</li>
								
																					
					   				 
					   			   </ul>
								 
					   	   </div>
					   </div>
					   
				   <div class="page">
					     
					     <el-pagination
					       layout="prev, pager, next"
					       :total="totaled"
						   @current-change="picks">
					     </el-pagination>
					   </div>
					   
					    <el-dialog
					   :visible.sync="dialogVisible"
					      width="800"
					     :before-close="handleClose"
					   >
					    <div class="product-st">
					    	 
					    			   <div class="pic">
					    				  <div class="l1">
					    					
					    					 <div class="block">
					    						<img :src="proImg" />
					    					   </div>
					    				  </div>
					    			
					    			   </div>
					    			    <div class="txt">
					    					<h2>{{pro.title}}</h2>
					    					<div class="l3" v-if="pro.kucun==0"><img src="../../assets/stock.png"></div>
					    					<div class="l4">
					    						$ {{pro.price_sale}}
					    						<span>Tax included</span>
					    					</div>
					    					<div class="l5">
					    						 <el-input-number size="mini"  v-model="num"  :min="1" :max="10" ></el-input-number>
					    						 <div class="cart-but" @click="sandYart">ADD TO CART</div>
					    					</div>
					    					<div class="wishlist">
					    					
					    						<div class="co2">
					    							Share：
					    														<a href="https://www.facebook.com/sharer.php?u=http://cn.fmhd.209.qiyundongli.cn/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
					    															
					    														<a href="http://twitter.com/share?text=FuelMe&url=http://cn.fmhd.209.qiyundongli.cn/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
					    							<a href="http://service.weibo.com/share/share.php?url=http://cn.fmhd.209.qiyundongli.cn/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>
					    							
					    						</div>
					    					
					    					</div>
					    				</div>
					    </div>
					    </el-dialog>
				
				
					</div>
				
			</el-tab-pane>
		    <el-tab-pane label="購物券" name="1">
				
				
				<div class="login-r1">
				
							<div class="gift-tap">
								<div class="h-button" :class="{'but2':sta==1}" @click="sandHans(1)">未使用</div>
								<div class="h-button" :class="{'but2':sta==2}" @click="sandHans(2)">已使用</div>
								<div class="h-button" :class="{'but2':sta==3}" @click="sandHans(3)">過期</div>
							</div>
				
					   <div class="home-arr gift-con">
						   
				
					   	   <div class="integral">
					   		   <ul>
								 
					   			<li v-for="item in hans">
									<div class="cont">
										<el-row gutter="20">
											<el-col span="5">
												
												<img class="pic" :src="item.image" />
											</el-col>
											 <el-col span="7" class="l1">
											<p>{{item.title}}</p>
											<p class="ink"><span>{{item.jifen}} points</span>          <span> *1</span></p>
											 
										</el-col>
											  <el-col span="7" class="l1 sim">
											  	<p>Beijing time :{{item.startTime}}</p>
											  	<p>~{{item.endTime}}</p>
											  	 
											  </el-col>
											   <el-col span="5" class="l2"><router-link :to="'/product/details?id='+item.inventoryId"><div v-if="item.status==1" class="h-button but2">TO USED</div></router-link> 
											   <div v-if="item.status==2" class="h-button">USED</div>
											    <div v-if="item.status==3" class="h-button">EXPIRED</div>
											   </el-col>
											
											  </el-row>
									</div>
								
								</li>
								
																					
					   				 
					   			   </ul>
								 
					   	   </div>
					   </div>
					   
				   <div class="page">
					     
					     <el-pagination
					       layout="prev, pager, next"
					       :total="totals"
						   @current-change="picks">
					     </el-pagination>
					   </div>
					   
					    <el-dialog
					   :visible.sync="dialogVisible"
					      width="800"
					     :before-close="handleClose"
					   >
					    <div class="product-st">
					    	 
					    			   <div class="pic">
					    				  <div class="l1">
					    					
					    					 <div class="block">
					    						<img :src="proImg" />
					    					   </div>
					    				  </div>
					    			
					    			   </div>
					    			    <div class="txt">
					    					<h2>{{pro.title}}</h2>
					    					<div class="l3" v-if="pro.kucun==0"><img src="../../assets/stock.png"></div>
					    					<div class="l4">
					    						$ {{pro.price_sale}}
					    						<span>Tax included</span>
					    					</div>
					    					<div class="l5">
					    						 <el-input-number size="mini"  v-model="num"  :min="1" :max="10" ></el-input-number>
					    						 <div class="cart-but" @click="sandYart">ADD TO CART</div>
					    					</div>
					    					<div class="wishlist">
					    					
					    						<div class="co2">
					    							Share：
					    														<a href="https://www.facebook.com/sharer.php?u=http://cn.fmhd.209.qiyundongli.cn/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
					    															
					    														<a href="http://twitter.com/share?text=FuelMe&url=http://cn.fmhd.209.qiyundongli.cn/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
					    							<a href="http://service.weibo.com/share/share.php?url=http://cn.fmhd.209.qiyundongli.cn/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>
					    							
					    						</div>
					    					
					    					</div>
					    				</div>
					    </div>
					    </el-dialog>
				
				
					</div>
				
				
			</el-tab-pane>
		 
		
		  </el-tabs>


	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center
  },
 data() {
    return {
	
	
		num: 1,
		dialogVisible: false,
		info:'',
		news:[],
		notice:[],
		total:'',
		totals:'',
		id:'',
		pro:'',
		proImg:'',
		page:1,
		pages:1,
		channel_id:0,
		hans:'',
		channel:'',
		exchange:0,
		sta:1,
		scene:1,
		hand:'',
		totaled:'',
		
	
		
    
    };
  },  mounted() {
	  
 this.channel_id = this.$route.query.id;
		this.sandMate();
		this.sandHans(this.sta);
		this.sandHand(this.scene);
		this.sandChan();
		this.sandCase();
		this.sandCart();
		
		},methods: {
			finding(it){
				
				this.proImg=it.image
				this.id=it.inventoryId
				this.dialogVisible=true
				this.sandCase()
			
			},
		
			
		sandCase(){
		
			this.$axios({
			  method: "post",
			  url: "service.php?action=product_detail",
			  data: {inventoryId:this.id},  
			}).then((res) => {
				let data=res.data;
			
				if(data.code==1){
					this.pro=data.data;
				}
			 
			});
		
		}, buff(item){
				this.channel_id=item
				this.sandMate()
			},handleClose(done) {
			this.num=1
			done();
       
      }, cancel(id){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=orders_qxOrder",
			  	  data: {order_id:id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  			
			  		this.$message.success(data.message);
			  			this.sandHand(this.scene);	
			  		}else{  
			  			this.$message.error(data.message);
			  			      
			  		}
			  	 
			  	});
			  
			  },sandYart(it){
		  this.id=it.inventoryId
				if(window.localStorage.getItem('user')== "undefined"){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.id,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
					
					
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},
			voucher(id){
			
							this.$axios({
							  method: "post",
							  url: "service.php?action=money_createTicket",
							  data: {ticket_id:id},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
								
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},
		
			collect(it){
				this.id=it.inventoryId
							if(window.localStorage.getItem('user')== "undefined"){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:0},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
								
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},
						pick(item){
							this.page=item;
							this.sandMate()
						},
			sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=money_jifenPdts",
				  data: {page:this.page},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.news=data.data
						this.exchange=data.my_exchange_num
						this.total=data.jifen
						
					}
				 
				});
			
			}, confirm(item){
			   	this.$axios({
			   	  method: "post",
			   	  url: "service.php?action=orders_qrshouhuo",
			   	  data: {orderId:item},  
			   	}).then((res) => {
			   		let data=res.data;
			   	
			   		if(data.code==1){
			   			
			   		this.$message.success(data.message);
					this.sandHand(this.scene);	
			   		}else{  
			   			this.$message.error(data.message);
			   			      
			   		}
			   	 
			   	});
			   
			   },picks(item){
							this.pages=item;
							this.sandHans()
						},sandHand(scene){
						this.scene=scene
				this.$axios({
				  method: "post",
				  url: "service.php?action=money_jifenOrderList",
				  data: {page:this.pages,scene:scene},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
								
						this.hand=data.data;
						this.totaled=data.count
						
					}
				 
				});
			
			},sandHans(status){
						this.sta=status
				this.$axios({
				  method: "post",
				  url: "service.php?action=money_ticketList",
				  data: {page:this.pages,status:status},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
								
						this.hans=data.data;
						this.totals=data.count
						
					}
				 
				});
			
			},sandChan(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_channel",
				  data: {},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.channel=data.data;
						
						
					}
				 
				});
			
			}
		}
};
</script>
<style lang="scss" scoped>
	.gift-tit{
		padding: 30px;
		height: 88px;
		background-color: #F8F8F8;
		text-align: center;
		p{
			font-size: 16px;
			font-weight: bolder;
		}
		h1{
			font-size: 41px;
			margin-top: 20px;
		}
		.con1{
			width: 50%;
			border-right: 1px solid #D2D2D2;
			float: left;
		}
		
	}
	.h-button{
			text-align: center;
			cursor: pointer;
			height:35px;
			line-height: 35px;
			background: #999;
			color: #FFFFFF;
			padding: 0 10px;
		}
	
		.but2{
			background: #000;
		}
	.but3{
		width: 84px;
		margin: 0 auto;
	}.but4{
		width: 105px;
		margin: 0 auto;
	}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{
	.gift-tap{
		padding: 20px;
		display: flex;
		justify-content: space-between;
		width:450px;
		margin: 0 auto;
	}
}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
	.page{
		text-align: center;
		margin:50px auto;
	}
.address{
	.re-con{
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		.re-tit{
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
	font-size: 16px;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: #333333;
	line-height: 24px;

}
.add-set{
	margin-left: 10px;
}
.convert{
	margin: 10px 0;
	span{
		background: #F8F8F8;
		padding:5px 10px;
	}

}
.home{
	.gift-con{
		.con{
			li{
				height:450px;
				.gift-t1{
					height: 50px;
				}
				.pic{
					height: 280px;
					img{
						height: 280px;
					}
				}
				.point{
					display: flex;
					justify-content: space-between;
					align-items: center;
					span{
						font-size: 20px;
						color: #010101;
						
					}
				}
			}
		}
	}
}
.cen-ord1{
background: #F8F8F8;
padding: 20px;
margin-bottom: 20px;
}
.integral{
	color:#989898;
	ul{
		border-top: 1px solid #EFEFEF;
	}
	li{
		border-bottom: 1px solid #EFEFEF;
		.convert{
			background: #F4F4F4;
			width: 120px;
			text-align: center;
			padding: 5px 0;
		}
		.cont{
				padding: 20px;
				p{
					font-size: 14px;
				}
			b{
				font-size: 16px;
				color: #1F1F1F;
				text-align: center;
			}
			.pic{
				width: 100%;
			}
			.l1{
				
				font-size: 14px;
				font-family: Arial;
				font-weight: 400;
				color: #212121;
				line-height:25px;
				
				.ink{
					display: flex;
					justify-content: space-between;
				}
				

			}
			.l2{
				padding: 40px;
				.h-button{
					margin-left:70px;
				}
			}
			.sim{
				color: #656565;
				text-align: center;
				span{
				
					font-size: 14px;
					font-family: Arial;
					font-weight: 400;
					text-decoration: underline;
					a{
						color: #010101;
					}
					
					
				
				}
			}
		}
	
	}
}

</style>